document.addEventListener('DOMContentLoaded', function () {
    let options;

    if (window.innerWidth < 768) {
      options = document.querySelectorAll('.option-msite');
    } else {
      options = document.querySelectorAll('.option');
    }

    // Function to apply border-left style to initially selected option
    function setInitialBorder() {
        const initiallySelected = document.querySelector('.option.selected');
        if (initiallySelected) {
          
          if (window.innerWidth < 768) {
              // For mobile
              initiallySelected.style.borderLeft = 'none';
              initiallySelected.style.borderBottom = '5px solid #FE7900';

          } else {
              // For desktop
              initiallySelected.style.borderBottom = 'none';
              initiallySelected.style.borderLeft = '5px solid #FE7900';
          }

            // initiallySelected.style.borderLeft = '5px solid #FE7900';
        }
    }
    // Apply border-left style to initially selected option
    setInitialBorder();

    window.addEventListener('resize', setInitialBorder);

    // Event listener for click on options
    options[0].classList.add('selected');
    options[0].classList.add('font-bold');
    options.forEach(option => {
        option.addEventListener('click', function () {
            // Remove 'selected' class from all options
            options.forEach(opt => {
                opt.classList.remove('selected');
                opt.classList.remove('font-bold'); // Remove font-bold class
            });

            // Add 'selected' class to the clicked option
            this.classList.add('selected');
            this.classList.add('font-bold');

            // Remove border style from all options
            options.forEach(opt => {
                opt.style.borderLeft = 'none';
                opt.style.borderBottom = 'none';
            });

            // Remove border-left style from all options
            options.forEach(opt => opt.style.borderLeft = '');

              // Apply border style to the selected option based on screen width
            if (window.innerWidth < 768) {
                  this.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' });
                // For mobile
                this.style.borderLeft = 'none';
                this.style.borderBottom = '5px solid #FE7900';
            } else {
                // For desktop
                this.style.borderBottom = 'none';
                this.style.borderLeft = '5px solid #FE7900';
            }

            this.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });

        });
    });
});